import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    wrapper:{
        marginTop: '160px',
        marginBottom: '100px'
    },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  avatar: {
    margin: theme.spacing(1),
    // backgroundColor: theme.palette.warning.main,
    background: '#e6b800' 
  },
  form: {
    width: '100%', 
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    // background: theme.palette.warning.main,
    background: '#e6b800',
    transition:'all 0.3s ease-in-out',
   '&:hover':{
    background: '#b38f00',
    color:'whitesmoke',
    transition:'all 0.3s ease-in-out'
   },
    
  },
  
  
  googleButton: {
    marginBottom: theme.spacing(2),
    background: '#df5e53',
    transition:'all 0.3s ease-in-out',
    '&:hover':{
      background:'#db4437',
      transition:'all 0.3s ease-in-out'
    }
  },
}));